import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-authenticating-animation',
  templateUrl: './authenticating.component.html',
  styleUrls: ['./authenticating.component.css'],
})
export class AuthenticatingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
